export const INSTANCE_TOKEN = 'instance_token';
export const ACCESS_TOKEN_MA = 'access_token_ma';
